import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingCommunity } from "@tabler/icons-react";
import { EmpresasDef } from "./EmpresasDef";

//export const EmpresasHelpText = "* Agregue aquí las Empresas que pertenecen al Grupo. Estas son las empresas disponibles para asociar a las Tiendas.";
export const EmpresasHelpText = "* Aquí tendra la lista de las empresas. Podra ver desde empresas disponibles para asociar a las tiendas, cómo tambien, empresas asignadas a numerosas tiendas y grupos.";
export const EmpresasIcon = IconBuildingCommunity;

export class Empresas extends Entity<EmpresasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new EmpresasDef(), parentKeys);
        this.Form = import('./EmpresasForm').then((module) => module.EmpresasForm);
        this.Title = "Empresas";
        this.HelpText = EmpresasHelpText;
        this.Icon = EmpresasIcon;
    }
}